import useFilterParams from '@/utils/UseFilterParams';
import PromptsTreeRoot from './tree/PromptsTreeRoot';
import PromptsWorkspace from './workspace/PromptsWorkspace';

export type PromptsFiltersParams = {
  prompt?: number;
  path?: number[];
};

export default function PromptsPageContent() {
  const { filterParams } = useFilterParams<PromptsFiltersParams>();
  return (
    <div className="flex gap-4 w-full h-full">
      <PromptsTreeRoot />
      <PromptsWorkspace key={filterParams.getAll('path')?.toString()} />
    </div>
  );
}
